import { rateCardsApi, subscriptionRateCardsApi } from "client/api-v2";
import type { DraftRateCardAssignmentResponse, RateCard, RateCardTermsDto } from "client/api-v2";

export async function getRateCards(
  params: {
    search?: string;
    page?: number;
    pageSize?: number;
    sortFieldName?: string;
    sortDirection?: "Asc" | "Desc";
  },
  signal: AbortSignal
): Promise<{ items: RateCard[]; totalItems: number }> {
  const { data } = await rateCardsApi.getV2RateCards({
    query: {
      // code and label are left unset: the list page searches both at once via `search`,
      // which the API rejects when combined with either per-field filter.
      search: params.search,
      page: params.page || 1,
      pageSize: params.pageSize || 25,
      sortFieldName: params.sortFieldName,
      sortDirection: params.sortDirection,
    },
    signal,
  });

  return {
    items: data.items || [],
    totalItems: data.totalItems || 0,
  };
}

export async function getRateCardByCode(rateCardCode: string): Promise<RateCard> {
  const { data } = await rateCardsApi.getV2RateCardsByCode({ path: { code: rateCardCode } });
  return data;
}

export async function createRateCard(terms: RateCardTermsDto): Promise<RateCard> {
  const { data } = await rateCardsApi.postV2RateCards({ body: terms });
  return data;
}

export async function draftRateCardAssignment(
  subscriptionId: string,
  newRateCard: RateCardTermsDto,
  reason: string
): Promise<DraftRateCardAssignmentResponse> {
  const { data } = await subscriptionRateCardsApi.postV2SubscriptionsBySubscriptionIdRateCardDrafts({
    path: { subscriptionId },
    body: { newRateCard, reason },
  });
  return data;
}

export async function activateDraftRateCardAssignment(subscriptionId: string, assignmentId: string): Promise<void> {
  await subscriptionRateCardsApi.postV2SubscriptionsBySubscriptionIdRateCardDraftsByAssignmentIdActivate({
    path: { subscriptionId, assignmentId },
  });
}
